import { useState } from "react";
import axios from "axios";

function ContactForm() {
  const [formData, setFormData] = useState({
    website: "",
    name: "",
    phone: "",
    email: "",
    make: "",
    model: "",
    year: "",
    message: "",
  });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess(false);
    setError(null);
    try {
      await axios.post(
        "https://jakesrvrepairs.com/api/contact/",
        formData,
        { headers: { "Content-Type": "application/json" } }
      );

      setSuccess(true);
      setFormData({ website: "", name: "", phone: "", email: "", make: "", model: "", year: "", message: "" });
    } catch (err) {
      if (err.response?.data?.error) {  
        setError(err.response.data.error);
      } else {
        setError("Failed to send message.");
      }
    }
  };

  return (
    <div className="w-full h-full min-h-[400px] mx-auto px-4">
      <div className="bg-neutral rounded-xl shadow-md p-6 sm:p-8">
        <h2 className="text-3xl font-bold text-black mb-4 text-center">Send Us a Message</h2>
        {success && <p className="text-black mb-4 text-center">Your message was sent successfully!</p>}
        {error && <p className="text-black mb-4 text-center">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="text" name="website" value={formData.website} onChange={handleChange} className="hidden" />
          <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required className="w-full border border-gray-300 p-3 rounded-lg" />
          <input type="tel" name="phone" placeholder="Your Phone Number" value={formData.phone} onChange={handleChange} className="w-full border border-gray-300 p-3 rounded-lg" />
          <input type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required className="w-full border border-gray-300 p-3 rounded-lg" />
          <input type="text" name="make" placeholder="RV Make" value={formData.make} onChange={handleChange} className="w-full border border-gray-300 p-3 rounded-lg" />
          <input type="text" name="model" placeholder="RV Model" value={formData.model} onChange={handleChange} className="w-full border border-gray-300 p-3 rounded-lg" />
          <input type="number" name="year" placeholder="RV Year" value={formData.year} onChange={handleChange} className="w-full border border-gray-300 p-3 rounded-lg" />
          <textarea name="message" placeholder="Tell us more about your RV so we can better assist you!" value={formData.message} onChange={handleChange} required rows="5" className="w-full border border-gray-300 p-3 rounded-lg" />
          <div className="text-center">
            <button type="submit" className="bg-black text-white px-6 py-2 rounded-lg hover:bg-secondary transition font-medium">
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ContactForm;
